import { render } from "./StorageRbdImageSelection.vue?vue&type=template&id=6fdf07d4&scoped=true"
import script from "./StorageRbdImageSelection.vue?vue&type=script&lang=js"
export * from "./StorageRbdImageSelection.vue?vue&type=script&lang=js"

import "./StorageRbdImageSelection.vue?vue&type=style&index=0&id=6fdf07d4&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdf07d4"]])

export default __exports__